/**
 * 发行平台-统一发售详情页
 */
import './index.scss';
import NFTHeader from "@/components/NFTHeader";
import React, {useEffect, useState} from "react";
import WordWhatCard from "@/view/ape/SaleDetail/components/WordWhatCard";
import DetailCard from "@/view/nftPad/saleDetail/components/DetailCard";
import IntroduceCard from "@/view/ape/SaleDetail/components/IntroduceCard";
import MarkingCard from "@/view/ape/SaleDetail/components/MarkingCard";
import NoteBuyCard from "@/view/ape/SaleDetail/components/NoteBuyCard";
import BottomBuy from "@/view/nftPad/saleDetail/components/BottomBuy";
import {hideLoading, showLoading} from "@/components/loading";
import Service from "@/view/nftPad/service";
import {Toast} from "antd-mobile";
import {useLocation} from "react-router";
import {getUrlAllParams} from "@/utils/publicFun";

const SaleDetail = () => {
  const { search } = useLocation()
  const params = getUrlAllParams(search.slice(1))
  const [data, setData] = useState()

  const getData = async (loading = false) => {
    try {
      window.localStorage.removeItem('source3d')
      if (loading) showLoading();
      const res = await Service.getCollectionInfo({
        activityCode: params?.activityCode,
      })
      if (loading) hideLoading()
      if (res.code !== '000000') throw res.msg
      setData(res?.data)
      if(res?.data?.image3dTop && res?.data?.image3dLeft1 && res?.data?.image3dLeft2) {
        const source3d = [
          res.data.image3dTop,
          res.data.image3dTop,
          res.data.image3dLeft1,
          res.data.image3dLeft1,
          res.data.image3dLeft2,
          res.data.image3dLeft2,
        ]
        window.localStorage.setItem('source3d', JSON.stringify(source3d))
      }
    } catch (error) {
      hideLoading()
      Toast.show(error)

    }
  }

  useEffect(() => {
    getData(true)
  }, [])

  return (
    <div className="pad-sale-detail">
      <NFTHeader leftImg={require('@/assets/img/icon/go_back.png')} />
      <div className="pad-sale-detail--body">
        <div className="pad-sale-detail--body--content">
          <img src={data?.topBackgroundImage} alt="" style={{ width: '100%', height: 'auto', display: 'block' }}/>
          <div className="pad-sale-detail--body--content-box">
            <WordWhatCard
              dataSouce={{title: data?.boxName}}
              sources={[
                data?.image3dTop,
                data?.image3dTop,
                data?.image3dLeft1,
                data?.image3dLeft1,
                data?.image3dLeft2,
                data?.image3dLeft2,
              ]}
            />
            <DetailCard dataSource={data}/>
            <IntroduceCard dataSouce={{collectModuleList: [
                {title: '藏品介绍', subTitle: data?.introduction},
                {title: '活动特征', subTitle: data?.features},
              ]}}/>
            <MarkingCard />
            <NoteBuyCard />
          </div>
        </div>
        <div className="bottom">
          <BottomBuy dataSource={{
            collectionId: data?.collectionId,
            price: data?.price,
            saleBatchInfo: data?.saleBatchInfo,
            hasIntegralDeduction: data?.hasIntegralDeduction,
            // hasComicIntegral: data?.hasComicIntegral,
            activityCode: data?.activityCode,
          }}/>
        </div>
      </div>
    </div>
  )
}
export default SaleDetail